import { removeMask } from "src/utils/functions";

export interface CDBResponse {
  valorFinal: number;
  valorFinalLiquido: number;
  totalInvestido: number;
  rendimentoLiquido: number;
  rendimentoBruto: number;
  impostoRenda: number;
  taxaAnualCDB: number;
  rendimentoBrutoPercentual: number;
}
export function calcularCDB(
  investimentoInicial: string,
  investimentoMensal: string,
  fatorCDI: number,
  tempoRendimento: string,
  tempoRendimentoType: "anual" | "mensal",
) {
  const CDI_ANUAL = 0.149;

  const investimentoInicialMasked = removeMask(investimentoInicial);
  const investimentoMensalMasked = removeMask(investimentoMensal);

  const taxaAnualCDB = CDI_ANUAL * fatorCDI;

  const tempoEmMeses =
    tempoRendimentoType === "anual"
      ? parseInt(tempoRendimento) * 12
      : parseInt(tempoRendimento);

  const taxaMensal = Math.pow(1 + taxaAnualCDB, 1 / 12) - 1;

  const valorFinalInicial =
    investimentoInicialMasked * Math.pow(1 + taxaMensal, tempoEmMeses);

  let valorFinalAportes = 0;

  for (let i = 1; i <= tempoEmMeses; i++) {
    valorFinalAportes +=
      investimentoMensalMasked * Math.pow(1 + taxaMensal, tempoEmMeses - i);
  }

  const valorFinal = valorFinalInicial + valorFinalAportes;

  const totalInvestido =
    investimentoInicialMasked + investimentoMensalMasked * tempoEmMeses;

  const rendimentoBruto = valorFinal - totalInvestido;

  const rendimentoBrutoPercentual =
    totalInvestido > 0
      ? Math.round((rendimentoBruto / totalInvestido) * 100 * 100) / 100
      : 0;

  const dias = tempoEmMeses * 30;

  function obterAliquotaIR(dias: number): number {
    if (dias <= 180) return 0.225;
    if (dias <= 360) return 0.2;
    if (dias <= 720) return 0.175;
    return 0.15;
  }

  const aliquotaIR = obterAliquotaIR(dias);
  const impostoDeRenda = rendimentoBruto * aliquotaIR;

  const rendimentoLiquido = rendimentoBruto - impostoDeRenda;
  const valorFinalLiquido = totalInvestido + rendimentoLiquido;

  return {
    valorFinal,
    valorFinalLiquido,
    totalInvestido,
    rendimentoBruto,
    rendimentoLiquido,
    impostoRenda: impostoDeRenda,
    taxaAnualCDB: taxaAnualCDB * 100,
    rendimentoBrutoPercentual,
  };
}
